"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDateToString = exports.DateTimeObjZ = exports.DateObjZ = exports.DateTimeObjT = exports.DateObjT = exports.DateTimeObj = exports.DateObj = exports.lx = void 0;
const tBox = __importStar(require("@sinclair/typebox"));
const lx = __importStar(require("luxon"));
exports.lx = lx;
const zod_1 = require("zod");
const time_1 = require("./time");
const SECONDS_PER_DAY = 86_400;
const MILLISECONDS_PER_DAY = SECONDS_PER_DAY * 1000;
const FMT_ISO_DATE = 'yyyy-MM-dd';
const FMT_AUS_DATE = 'dd/MM/yyyy';
const FMT_AUS_DATE_SHORT = 'dd/MM/yy';
const FMT_ISO_DATETIME = 'yyyy-MM-dd HH:mm:ss';
const INVALID_INPUT = 'Invalid input for date';
class DateObj {
    lx;
    constructor(lxDate, suppressErrors) {
        const is_string = typeof lxDate === 'string';
        if (lxDate === undefined) {
            this.lx = lx.DateTime.now();
        }
        else if (is_string) {
            this.lx = lx.DateTime.fromFormat(lxDate, FMT_ISO_DATE);
        }
        else {
            this.lx = lxDate;
        }
        if (!this.lx.isValid && !suppressErrors) {
            console.error(`Invalid date`, lxDate);
            if (is_string) {
                console.error(`Entered: "${lxDate}"`);
            }
            console.warn(this.lx.invalidReason, this.lx.invalidExplanation);
        }
    }
    add(quantity, units) {
        return new DateObj(this.lx.plus({ [units]: quantity ?? 0 }));
    }
    addDays(days) {
        return this.add(days, 'days');
    }
    subtract(quantity, units) {
        return this.add(-(quantity ?? 0), units);
    }
    subtractDays(days) {
        return this.subtract(days, 'days');
    }
    diffDays(other) {
        const other_ts = other?.lx.toMillis() ?? Date.now();
        return Math.round((this.lx.toMillis() - other_ts) / MILLISECONDS_PER_DAY);
    }
    diffMonths(other) {
        return this.lx.diff(other?.lx ?? lx.DateTime.now(), 'months').months;
    }
    diffYears(other) {
        return this.lx.diff(other?.lx ?? lx.DateTime.now(), 'years').years;
    }
    daysAgo() {
        return -this.diffDays();
    }
    unix() {
        return this.lx.toMillis();
    }
    get u() {
        return this.unix();
    }
    datetime(hours, minutes, seconds, milliseconds) {
        return DateTimeObj.create({
            year: this.lx.year,
            month: this.lx.month,
            day: this.lx.day,
            hour: hours ?? 0,
            min: minutes ?? 0,
            sec: seconds ?? 0,
            ms: milliseconds ?? 0,
        });
    }
    fmt(fmt = FMT_ISO_DATE) {
        return this.lx.toFormat(fmt);
    }
    fmtDMY(options) {
        return this.fmt((options?.shortYear ?? false) ? FMT_AUS_DATE_SHORT : FMT_AUS_DATE);
    }
    get raw() {
        return this.lx.toJSDate();
    }
    toJSON() {
        return this.fmt();
    }
    get isValid() {
        return this.lx.isValid;
    }
    toString() {
        return `[Date: ${this.fmt()}]`;
    }
    static create(year, month, day) {
        return new DateObj(lx.DateTime.local(year, month, day));
    }
    static today() {
        return DateTimeObj.now().date();
    }
    static parseLuxon(lxObj) {
        return new DateObj(lxObj);
    }
    static parse(value, fmt = FMT_ISO_DATE, suppressErrors = false) {
        const warn = (baseMsg, ...messages) => {
            if (!suppressErrors) {
                console.warn(baseMsg, ...messages);
            }
        };
        if (!value) {
            return null;
        }
        if (value instanceof DateObj) {
            if (!value.isValid) {
                warn('Invalid DateObj to DateObj', value);
            }
            return value;
        }
        if (value instanceof DateTimeObj) {
            if (!value.isValid) {
                warn('Invalid DateTimeObj to DateObj', value);
            }
            return value.date();
        }
        if (value instanceof Date) {
            const parsedDate = lx.DateTime.fromJSDate(value);
            if (!parsedDate.isValid) {
                warn('Invalid Date to DateObj', value);
            }
            return new DateObj(parsedDate);
        }
        if (fmt === FMT_ISO_DATE) {
            return DateObj.parseISO(value, suppressErrors);
        }
        return new DateObj(lx.DateTime.fromFormat(value, fmt), suppressErrors);
    }
    static parseStrict(value, fmt = FMT_ISO_DATE) {
        const err = { error: { msg: INVALID_INPUT } };
        if (value === null || value === undefined) {
            return { result: null, error: null };
        }
        if (value === '') {
            return err;
        }
        if (value instanceof DateObj) {
            const v = DateObj.parse(value);
            return v && v.isValid ? { result: v, error: null } : err;
        }
        if (value instanceof DateTimeObj) {
            const v = DateObj.parse(value);
            return v && v.isValid ? { result: v, error: null } : err;
        }
        if (value instanceof Date) {
            const v = DateObj.parse(value);
            return v && v.isValid ? { result: v, error: null } : err;
        }
        const v = DateObj.parse(value, fmt, true);
        return v && v.isValid ? { result: v, error: null } : err;
    }
    static parseISO(value, suppressErrors = false) {
        if (!value) {
            return null;
        }
        const yyyy = Number(value.slice(0, 4));
        const mm = Number(value.slice(5, 7));
        const dd = Number(value.slice(8, 10));
        return new DateObj(lx.DateTime.local(yyyy, mm, dd), suppressErrors);
    }
}
exports.DateObj = DateObj;
class DateTimeObj {
    lx;
    constructor(lxDate, suppressErrors) {
        const is_string = typeof lxDate === 'string';
        if (lxDate === undefined) {
            this.lx = lx.DateTime.now();
        }
        else if (is_string) {
            this.lx = lx.DateTime.fromFormat(lxDate, FMT_ISO_DATETIME);
        }
        else {
            this.lx = lxDate;
        }
        if (!this.lx.isValid && !suppressErrors) {
            console.error(`Invalid date`, lxDate);
            if (is_string) {
                console.error(`Entered: "${lxDate}"`);
            }
            console.warn(this.lx.invalidReason, this.lx.invalidExplanation);
        }
    }
    date() {
        const y = this.lx.year;
        const m = this.lx.month;
        const d = this.lx.day;
        return DateObj.create(y, m, d);
    }
    time() {
        return this.lx.toFormat('HH:mm:ss');
    }
    add(quantity, units) {
        return new DateTimeObj(this.lx.plus({ [units]: quantity ?? 0 }));
    }
    subtract(quantity, units) {
        return this.add(-(quantity ?? 0), units);
    }
    diffDays(other) {
        return this.diffMilliseconds(other) / MILLISECONDS_PER_DAY;
    }
    daysAgo() {
        return -this.diffDays();
    }
    millisecondsAgo() {
        return -this.diffMilliseconds();
    }
    diffMilliseconds(other) {
        const other_ts = other?.lx.toMillis() ?? Date.now();
        return this.lx.toMillis() - other_ts;
    }
    unix() {
        return this.lx.toMillis();
    }
    get u() {
        return this.unix();
    }
    fmt(fmt = FMT_ISO_DATETIME) {
        return this.lx.toFormat(fmt);
    }
    fmtDMY(input) {
        const fmtTime = input.seconds ? 'HH:mm:ss' : 'HH:mm';
        const fmtDay = input.weekday ? 'ccc ' : '';
        const fmtDate = (input.shortYear ?? false) ? FMT_AUS_DATE_SHORT : FMT_AUS_DATE;
        return this.fmt(`${fmtDay}${fmtDate} ${fmtTime}`);
    }
    get raw() {
        return this.lx.toJSDate();
    }
    toJSON() {
        return this.fmt();
    }
    get isValid() {
        return this.lx.isValid;
    }
    toString() {
        return `[Date: ${this.fmt()}]`;
    }
    static create(input) {
        return new DateTimeObj(lx.DateTime.fromObject({
            year: input.year,
            month: input.month,
            day: input.day,
            hour: input.hour ?? 0,
            minute: input.min ?? 0,
            second: input.sec ?? 0,
            millisecond: input.ms ?? 0,
        }));
    }
    static now() {
        return new DateTimeObj(lx.DateTime.now());
    }
    static parse(value, fmt = FMT_ISO_DATETIME, suppressErrors = false) {
        const warn = (baseMsg, ...messages) => {
            if (!suppressErrors) {
                console.warn(baseMsg, ...messages);
            }
        };
        if (!value) {
            return null;
        }
        if (value instanceof Date) {
            const parsedDate = lx.DateTime.fromJSDate(value);
            if (!parsedDate.isValid) {
                warn('Invalid Date to DateTimeObj', value);
            }
            return new DateTimeObj(parsedDate);
        }
        if (value instanceof DateTimeObj) {
            if (!value.isValid) {
                warn('Invalid DateTimeObj to DateTimeObj', value);
            }
            return value;
        }
        if (fmt === FMT_ISO_DATETIME) {
            return DateTimeObj.parseISO(value, suppressErrors);
        }
        return new DateTimeObj(lx.DateTime.fromFormat(value, fmt), suppressErrors);
    }
    static parseStrict(value, fmt = FMT_ISO_DATETIME) {
        const err = { error: { msg: INVALID_INPUT } };
        if (value === null || value === undefined) {
            return { result: null, error: null };
        }
        if (value === '') {
            return err;
        }
        if (value instanceof DateTimeObj) {
            const v = DateTimeObj.parse(value);
            return v && v.isValid ? { result: v, error: null } : err;
        }
        if (value instanceof DateObj) {
            const v = value.datetime();
            return v && v.isValid ? { result: v, error: null } : err;
        }
        if (value instanceof Date) {
            const v = DateTimeObj.parse(value);
            return v && v.isValid ? { result: v, error: null } : err;
        }
        const v = DateTimeObj.parse(value, fmt, true);
        return v && v.isValid ? { result: v, error: null } : err;
    }
    static parseISO(value, suppressErrors = false) {
        if (!value) {
            return null;
        }
        const year = Number(value.slice(0, 4));
        const month = Number(value.slice(5, 7));
        const day = Number(value.slice(8, 10));
        const hour = Number(value.slice(11, 13));
        const min = Number(value.slice(14, 16));
        const sec = Number(value.slice(17, 19));
        return new DateTimeObj(lx.DateTime.local(year, month, day, hour, min, sec), suppressErrors);
    }
    static parseUnix(value) {
        return new DateTimeObj(lx.DateTime.fromMillis(value));
    }
    static parseLuxon(lxObj) {
        return new DateTimeObj(lxObj);
    }
    static combine(date, time) {
        const dateObj = date instanceof DateObj ? date : DateObj.parse(date);
        const timeObj = time_1.TimeObj.parse(time);
        if (!dateObj) {
            throw new Error(`Invalid date: ${String(date)}`);
        }
        if (!timeObj) {
            throw new Error(`Invalid time: ${time}`);
        }
        return DateTimeObj.parse(`${dateObj.fmt()} ${timeObj.fmt()}`);
    }
}
exports.DateTimeObj = DateTimeObj;
tBox.TypeRegistry.Set('DateObjParserFormat', (_schema, value) => {
    if (value instanceof DateObj) {
        return value.lx.isValid;
    }
    if (value instanceof DateTimeObj) {
        return value.lx.isValid;
    }
    if (value instanceof Date) {
        return true;
    }
    if (typeof value === 'string') {
        return ((tBox.FormatRegistry.Get('date')?.(value) ?? false) ||
            (tBox.FormatRegistry.Get('date-time')?.(value) ?? false));
    }
    return false;
});
tBox.TypeRegistry.Set('DateTimeObjParserFormat', (_schema, value) => {
    if (value instanceof DateTimeObj) {
        return value.lx.isValid;
    }
    if (value instanceof DateObj) {
        return value.lx.isValid;
    }
    if (value instanceof Date) {
        return true;
    }
    if (typeof value === 'string') {
        return ((tBox.FormatRegistry.Get('date-time')?.(value) ?? false) ||
            (tBox.FormatRegistry.Get('date')?.(value) ?? false));
    }
    return false;
});
const DateObjT = (description) => tBox.Type.Transform(tBox.Type.Unsafe({
    [tBox.Kind]: 'DateObjParserFormat',
    type: 'string',
    format: 'date',
    description,
}))
    .Decode((value) => {
    if (value instanceof Date) {
        return DateObj.parse(value);
    }
    if (typeof value === 'string') {
        return DateObj.parse(value);
    }
    if (value instanceof DateObj) {
        return value;
    }
    if (value instanceof DateTimeObj) {
        return DateObj.parse(value.fmt());
    }
    throw new Error(`Invalid date input: ${String(value)}`);
})
    .Encode((value) => value.fmt());
exports.DateObjT = DateObjT;
const DateTimeObjT = (description) => tBox.Type.Transform(tBox.Type.Unsafe({
    [tBox.Kind]: 'DateTimeObjParserFormat',
    type: 'string',
    format: 'date-time',
    description,
}))
    .Decode((value) => {
    if (value instanceof Date) {
        return DateTimeObj.parse(value);
    }
    if (typeof value === 'string') {
        return DateTimeObj.parse(value);
    }
    if (value instanceof DateTimeObj) {
        return value;
    }
    throw new Error(`Invalid date-time input: ${String(value)}`);
})
    .Encode(value => value.fmt());
exports.DateTimeObjT = DateTimeObjT;
exports.DateObjZ = zod_1.z.iso.date().transform(value => DateObj.parseISO(value));
exports.DateTimeObjZ = zod_1.z.iso
    .datetime({ local: true })
    .transform(value => DateTimeObj.parseISO(value));
const convertDateToString = (object) => {
    if (object === null) {
        return null;
    }
    if (Array.isArray(object)) {
        return object.map(exports.convertDateToString);
    }
    if (object instanceof DateObj) {
        return object.fmt();
    }
    if (object instanceof DateTimeObj) {
        return object.fmt();
    }
    if (typeof object === 'object') {
        return Object.fromEntries(Object.entries(object).map(([key, value]) => [
            key,
            (0, exports.convertDateToString)(value),
        ]));
    }
    return object;
};
exports.convertDateToString = convertDateToString;
//# sourceMappingURL=dates.js.map